import { Link } from 'react-router-dom';
import type { Comic } from '@/types/comic';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/comic/${comic.slug}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg bg-background-100">
        <div className="aspect-[3/4] overflow-hidden">
          <img
            src={comic.coverImage}
            alt={comic.title}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        {comic.status === '连载中' && (
          <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-full font-label">
            连载
          </span>
        )}
        {comic.status === '已完结' && (
          <span className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded-full font-label">
            完结
          </span>
        )}
        <div className="absolute top-2 right-2 bg-background-950/70 text-background-50 text-xs px-1.5 py-0.5 rounded font-label">
          {comic.rating}
        </div>
      </div>

      <div className="mt-2.5 px-0.5">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
          <span>{comic.author}</span>
          <span className="w-0.5 h-0.5 rounded-full bg-foreground-400"></span>
          <span>{formatViews(comic.views)}次</span>
        </div>
        <div className="flex flex-wrap gap-1 mt-1.5">
          {comic.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="text-[10px] px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 font-label"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}